import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

interface StatusTagProps {
  status: 'REJECTED' | 'IN_PROGRESS' | 'COMPLETED' | 'PENDING';
}

/**
 * A component that displays a status tag with a given status
 * @param {{status: 'REJECTED' | 'IN_PROGRESS' | 'COMPLETED' | 'PENDING'}} props
 * @returns {JSX.Element}
 */
const StatusCircle: React.FC<StatusTagProps> = ({ status }) => {
  const theme = useTheme();

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'REJECTED':
        return '#FF6F78';
      case 'IN_PROGRESS':
        return '#FFD80D';
      case 'COMPLETED':
        return '#7EBB00';
      case 'PENDING':
        return '#A0A0A0';
      default:
        return theme.palette.grey[500];
    }
  };

  return (
    <Box
      sx={{
        width: '14px',
        height: '14px',
        borderRadius: '50%',
        backgroundColor: getStatusColor(status),
      }}
    />
  );
};

export default StatusCircle;
